module.exports = __webpack_public_path__ + "static/media/favicon-logo1.bd7d5fac.webp";